import PropTypes from "prop-types";
import { StyledNavLink } from "./nav-linkl.style";

const NavLink = ({ children, ...props }) => {
    return (
        <StyledNavLink activeClassName="active" partiallyActive={true} {...props}>
            {children}
        </StyledNavLink>
    );
};

NavLink.propTypes = {
    children: PropTypes.node,
};

export default NavLink;
